import { useKeycloak } from '@react-keycloak/web';
import axios, { AxiosInstance } from 'axios';

export type AxiosInstanceProvider = () => AxiosInstance;

export const useAuthorizedAxios = (): AxiosInstanceProvider => {
  const { keycloak, initialized: keycloakInitialized } = useKeycloak();
  const keycloakToken = keycloak.token;
  if (!keycloakInitialized) {
    console.warn('Authorization method not initialized.');
  } else if (keycloakToken === undefined) {
    console.warn('No token provided.');
  } else if (keycloak.isTokenExpired()) {
    console.warn('Token expired.');
  }
  return keycloakToken === undefined
    ? () => axios.create()
    : () => axios.create({
      headers: { Authorization: `Bearer ${keycloakToken}` }
    });
};